import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  AsyncDataItem,
  AsyncDataItemState,
  AuditLogEntry,
  idleDataItem,
  IPaginationMeta,
  isLoading,
  wrapAsAsyncDataItem
} from '@pharvio/core/shared';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuditLogService } from '../services/audit-log.service';
import { LoadAuditLogs } from './audit-log.actions';

export interface AuditLogStateModel {
  entries: AsyncDataItem<AuditLogEntry[]>;
  meta: IPaginationMeta | null;
}

@State<AuditLogStateModel>({
  name: 'auditLog',
  defaults: {
    entries: idleDataItem([]),
    meta: null
  }
})
@Injectable()
export class AuditLogState {
  private readonly svc = inject(AuditLogService);

  @Selector()
  static entries(state: AuditLogStateModel): AsyncDataItem<AuditLogEntry[]> {
    return state.entries;
  }

  @Selector()
  static meta(state: AuditLogStateModel): IPaginationMeta | null {
    return state.meta;
  }

  @Selector()
  static loading(state: AuditLogStateModel): boolean {
    return isLoading(state.entries);
  }

  @Action(LoadAuditLogs)
  loadEntries(
    ctx: StateContext<AuditLogStateModel>,
    { params }: LoadAuditLogs
  ) {
    ctx.patchState({
      entries: wrapAsAsyncDataItem({ data: ctx.getState().entries.data })
    });
    return this.svc.getEntries(params).pipe(
      tap(({ data, meta }) =>
        ctx.patchState({
          entries: wrapAsAsyncDataItem({
            data,
            state: AsyncDataItemState.LOADED
          }),
          meta
        })
      ),
      catchError((error) => {
        ctx.patchState({
          entries: wrapAsAsyncDataItem({
            data: ctx.getState().entries.data,
            state: AsyncDataItemState.ERROR,
            error
          })
        });
        return EMPTY;
      })
    );
  }
}
